<template>
  <div>
    <b-icon
      :id="`popover-${id_popover}`"
      :icon="icon"
      :variant="variant"
      class="popover-icon"
      :class="custom_class"
    ></b-icon>

    <b-popover
      :target="`popover-${id_popover}`"
      triggers="hover"
      :placement="placement"
      boundary="viewport"
    >
      <template #title>
        <slot name="title"></slot>
      </template>
      <slot></slot>
    </b-popover>
  </div>
</template>

<script>
export default {
  name: "InfoPopover",
  props: {
    id_popover: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "primary",
    },
    custom_class: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "info-circle-fill",
    },
    placement: {
      type: String,
      default: "top",
    },
  },
  computed: {},
};
</script>

<style scoped>
.popover-icon {
  cursor: pointer;
}
</style>
